import api from '../api/axios';

export interface Category {
  id?: number;
  name: string;
  description?: string;
  slug?: string;
  parentCategory?: number;
  image?: number;
  isActive?: boolean;
  sortOrder?: number;
}

const CategoryService = {
  getAll: (params?: any) => api.get('/product-categories', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/product-categories/${id}`, { 
      params: params || { populate: ['image', 'parentCategory', 'subCategories'] } 
    }),
  create: (data: Category) => api.post('/product-categories', { data }),
  update: (id: number, data: Partial<Category>) => 
    api.put(`/product-categories/${id}`, { data }),
  delete: (id: number) => api.delete(`/product-categories/${id}`),
};

export default CategoryService;

